// extracted by mini-css-extract-plugin
export default {"icon":"login-registartion-imgs_icon__E1WOS","iconRed":"login-registartion-imgs_iconRed__QNnqB"};